import type { PaymentsActivateTrialMutation } from '../../gen/stripe'
import { PaymentIntentStatus, PaymentStatus, SubscriptionStatus } from '../../gen/types'

type ActivateTrialResponse = PaymentsActivateTrialMutation['paymentsActivateTrial']

export function getActivateTrialPaymentResult(
  activateTrial: ActivateTrialResponse | null | undefined,
) {
  const subscription = activateTrial?.subscription
  const hostedUrl = subscription?.latestInvoice?.hostedUrl ?? null

  if (!subscription || (activateTrial?.errors?.length ?? 0) > 0) {
    return {
      paymentStatus: PaymentStatus.Failed,
      hostedUrl,
    }
  }

  const paymentIntentStatus = subscription.latestInvoice?.paymentIntent?.status

  switch (paymentIntentStatus) {
    case PaymentIntentStatus.Processing: {
      return {
        paymentStatus: PaymentStatus.Processing,
        hostedUrl,
      }
    }
    case PaymentIntentStatus.RequiresAction:
    case PaymentIntentStatus.RequiresCapture:
    case PaymentIntentStatus.RequiresConfirmation:
    case PaymentIntentStatus.RequiresPaymentMethod: {
      return {
        paymentStatus: PaymentStatus.RequiresAction,
        hostedUrl,
      }
    }
    case PaymentIntentStatus.Cancelled: {
      return {
        paymentStatus: PaymentStatus.Failed,
        hostedUrl,
      }
    }
    case PaymentIntentStatus.Succeeded: {
      return {
        paymentStatus: PaymentStatus.Succeeded,
        hostedUrl,
      }
    }
  }

  switch (subscription.status) {
    case SubscriptionStatus.Active:
    case SubscriptionStatus.Trialing: {
      return {
        paymentStatus: PaymentStatus.Succeeded,
        hostedUrl,
      }
    }
    case SubscriptionStatus.Pending: {
      return {
        paymentStatus: PaymentStatus.Processing,
        hostedUrl,
      }
    }
    default: {
      return {
        paymentStatus: PaymentStatus.Failed,
        hostedUrl,
      }
    }
  }
}
